// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1gwa7","insightsList":"newBusinessInsightsMenu_insightsList__c9ESN","active":"newBusinessInsightsMenu_active__2zCGN"};